import { render, staticRenderFns } from "./EditHsopDoc.vue?vue&type=template&id=23fac3d4&scoped=true"
import script from "./EditHsopDoc.vue?vue&type=script&lang=js"
export * from "./EditHsopDoc.vue?vue&type=script&lang=js"
import style0 from "./EditHsopDoc.vue?vue&type=style&index=0&id=23fac3d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fac3d4",
  null
  
)

export default component.exports